import { render, staticRenderFns } from "./NoFrontend.vue?vue&type=template&id=49bafd5e&"
import script from "./NoFrontend.vue?vue&type=script&lang=js&"
export * from "./NoFrontend.vue?vue&type=script&lang=js&"
import style0 from "./NoFrontend.vue?vue&type=style&index=0&id=49bafd5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports